const prod = {
  url: {
    API_URL: "https://api.torontoinfluencer.com/api/",
    STORAGE_URL: "https://api.torontoinfluencer.com/",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
    STORAGE_URL: "http://localhost:8000/",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
